import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { API_BASE_URL } from "../config";
import { setError } from "./errorSlice";
// Async thunks
export const fetchFeeStructuresByBatch = createAsyncThunk(
  "createPayment/fetchFeeStructuresByBatch",
  async ({ termId, batchId }, { rejectWithValue, dispatch }) => {
    try {
      const storedUser = localStorage.getItem("userInfo");
      if (!storedUser) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const { token } = JSON.parse(storedUser);
      if (!token) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }
      console.log("token", token);
      console.log(
        "path",
        `${API_BASE_URL}/api/FeeStructure/batch/${batchId}/${termId}`
      );
      const response = await fetch(
        `${API_BASE_URL}/api/FeeStructure/batch/${batchId}/${termId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (!response.ok) {
        throw new Error("Failed to fetch fee structures of the batch");
      }
      return response.json();
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    }
  }
);
export const assignFeeStructureToStudent = createAsyncThunk(
  "createPayment/assignFeeStructureToStudent",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const storedUser = localStorage.getItem("userInfo");
      if (!storedUser) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const { token } = JSON.parse(storedUser);
      if (!token) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }
      const errors = [];
      console.log("payload", payload);
      console.log("JSON.stringify(payload)", JSON.stringify(payload));
      try {
        const response = await fetch(
          `${API_BASE_URL}/api/StudentFeeStructure`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
          }
        );

        if (!response.ok) {
          const errMsg = await response.text();
          errors.push(`Failed to assign fee for students: ${errMsg}`);
        } else {
          console.log(`Assigned fee structure to student`);
        }
      } catch (error) {
        errors.push(`Failed to assign fee for student : ${error.message}`);
      }
      if (errors.length > 0) {
        console.log("Errors: ", errors);
        return rejectWithValue(errors);
      }
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    }
  }
);

export const fetchStudentFeeStructure = createAsyncThunk(
  "createPayment/fetchStudentFeeStructure",
  async ({ studentId, termId }, { rejectWithValue, dispatch }) => {
    try {
      const storedUser = localStorage.getItem("userInfo");
      if (!storedUser) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const { token } = JSON.parse(storedUser);
      if (!token) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }
      const response = await fetch(
        `${API_BASE_URL}/api/StudentFeeStructure/Student/${studentId}/${termId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        console.error(
          `Failed to assign fee for student ${studentId}`,
          await response.text()
        );
      } else {
        const data = await response.json();
        console.log(`Assigned fee structure to student ${studentId}`);
        console.log("data", data);
        return data;
      }
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    }
  }
);
export const fetchStudentTransactionDetail = createAsyncThunk(
  "createPayment/fetchStudentTransactionDetail",
  async ({ studentId, termId }, { rejectWithValue, dispatch }) => {
    try {
      const storedUser = localStorage.getItem("userInfo");
      if (!storedUser) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const { token } = JSON.parse(storedUser);
      if (!token) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }
      const response = await fetch(
        `${API_BASE_URL}/api/TransactionDetails/Student/${studentId}/${termId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        console.error(
          `Failed to assign fee for student ${studentId}`,
          await response.text()
        );
      } else {
        const data = await response.json();
        console.log(`Student transaction detail fetched successfully `);
        console.log("data", data);
        return data;
      }
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    }
  }
);
export const fetchPaymentInformation = createAsyncThunk(
  "createPayment/fetchPaymentInformation",
  async ({ batchId, termId }, { rejectWithValue, dispatch }) => {
    try {
      const storedUser = localStorage.getItem("userInfo");
      if (!storedUser) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const { token } = JSON.parse(storedUser);
      if (!token) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }
      const response = await fetch(
        `${API_BASE_URL}/api/PaymentInformation/TermAndBatch/${termId}/${batchId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok) {
        throw new Error("Failed to create fee structure");
      }
      return response.json();
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    }
  }
);

export const createPaymentTransaction = createAsyncThunk(
  "createPayment/createPaymentTransaction",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const storedUser = localStorage.getItem("userInfo");
      if (!storedUser) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const { token } = JSON.parse(storedUser);
      if (!token) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }
      const response = await fetch(
        `${API_BASE_URL}/api/TransactionDetails/perform-transaction`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );
      if (!response.ok) {
        throw new Error("Failed to fetch payment history");
      }
      return response.json();
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    }
  }
);
export const updatePaymentTransactionStatus = createAsyncThunk(
  "createPayment/createPaymentTransaction",
  async ({ id, payload }, { rejectWithValue, dispatch }) => {
    try {
      const storedUser = localStorage.getItem("userInfo");
      if (storedUser) {
        console.log("JSON.stringify(payload)", JSON.stringify(payload));
        const { token } = JSON.parse(storedUser);
        const response = await fetch(
          `${API_BASE_URL}/api/TransactionDetails/update-status/${id}`,
          {
            method: "PUT",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
          }
        );
        if (!response.ok) {
          throw new Error("Failed to update payment status");
        }
        return response.json();
      }
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    }
  }
);

// store/createPaymentSlice.js
export const fetchPaymentByTermAndStudent = createAsyncThunk(
  "payments/fetchPaymentByTermAndStudent",
  async ({ termId, studentId }, { rejectWithValue, dispatch }) => {
    try {
      const storedUser = localStorage.getItem("userInfo");
      if (!storedUser) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const { token } = JSON.parse(storedUser);
      if (!token) {
        dispatch(setError("Invalid session. Please log in again."));
        return rejectWithValue("Invalid session. Please log in again.");
      }

      const response = await fetch(
        `${API_BASE_URL}/api/PaymentInformation/TermAndStudent/${termId}/${studentId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to fetch payment history");
      }

      return await response.json();
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    }
  }
);

export const deleteFeeStructure = createAsyncThunk(
  "feeStructure/deleteFeeStructure",
  async (feeId, { rejectWithValue, dispatch }) => {
    try {
      const storedUser = localStorage.getItem("userInfo");
      if (!storedUser) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const { token } = JSON.parse(storedUser);
      if (!token) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }
      const response = await fetch(
        `${API_BASE_URL}/api/FeeStructure/${feeId}`,
        {
          method: "DELETE",
        }
      );
      if (!response.ok) {
        throw new Error("Failed to delete fee structure");
      }
      return feeId;
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    }
  }
);

export const fetchStudentCategories = createAsyncThunk(
  "feeStructure/fetchStudentCategories",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const storedUser = localStorage.getItem("userInfo");
      if (!storedUser) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const { token } = JSON.parse(storedUser);
      if (!token) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }
      const response = await fetch(`${API_BASE_URL}/api/Enum/StudentCategory`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch student categories");
      }
      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(
        "Error fetching student categories:",
        error.message
      );
    }
  }
);
const initialState = {
  batch_term_feeStructures: [],
  student_feeStructures: [],
  studentPayment: [],
  studentPaymentByTermAndStudent: [],

  transactionHistory: [],
  loading: false,
  error: null,
  selectedFeeStructure: null,
};

const paymentSlice = createSlice({
  name: "payments",
  initialState,
  reducers: {
    setSelectedFeeStructure: (state, action) => {
      state.selectedFeeStructure = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Fee Structures
      .addCase(fetchFeeStructuresByBatch.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFeeStructuresByBatch.fulfilled, (state, action) => {
        state.loading = false;
        state.batch_term_feeStructures = action.payload;
        console.log("state.batch_feeStructures", state.batch_feeStructures);
      })
      .addCase(fetchFeeStructuresByBatch.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      //
      .addCase(fetchStudentTransactionDetail.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStudentTransactionDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.transactionHistory = action.payload;
        console.log("state.transactionHistory", state.transactionHistory);
      })
      .addCase(fetchStudentTransactionDetail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      //fetchStudentFeeStructure
      .addCase(fetchStudentFeeStructure.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStudentFeeStructure.fulfilled, (state, action) => {
        state.loading = false;
        state.student_feeStructures = action.payload;
        console.log("state.batch_feeStructures", state.studnet_feeStructures);
      })
      .addCase(fetchStudentFeeStructure.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchStudentCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStudentCategories.fulfilled, (state, action) => {
        state.loading = false;

        const categoriesArray = Object.entries(
          action.payload.StudentCategory
        ).map(([value, name]) => ({
          value: parseInt(value),
          name: name,
        }));
        state.studentCategories = categoriesArray;
      })
      .addCase(fetchStudentCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // Create Fee Structure
      //
    .addCase(fetchPaymentByTermAndStudent.pending, (state) => {
  state.loading = true;
  state.error = null;
})
.addCase(fetchPaymentByTermAndStudent.fulfilled, (state, action) => {
  state.loading = false;
  state.studentPaymentByTermAndStudent = action.payload;
})
.addCase(fetchPaymentByTermAndStudent.rejected, (state, action) => {
  state.loading = false;
  state.error = action.payload;
})


      // Delete Fee Structure
      .addCase(deleteFeeStructure.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteFeeStructure.fulfilled, (state, action) => {
        state.feeStructures = state.feeStructures.filter(
          (fee) => fee.feeID !== action.payload
        );
      })
      .addCase(deleteFeeStructure.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { setSelectedFeeStructure, clearError } = paymentSlice.actions;
export default paymentSlice.reducer;
